<template>
  <div class="content">
    <van-address-edit
      :area-list="areaList"
      :show-delete="type === 'edit'"
      show-set-default
      :tel-validator="telValidator"
      :area-columns-placeholder="['请选择', '请选择', '请选择']"
      @save="onSave"
      @delete="onDelete"
      :address-info="AddressInfo"
    />
  </div>
</template>

<script>
import { areaList } from "@vant/area-data";
export default {
  data() {
    return {
      show: false,
      areaList,
      AddressInfo: {},
      manageType: "add",
    };
  },
  created() {
    let query = this.$route.query;
    this.type = query.type;
    let title = "新增收货地址";
    if (query.type === "edit") {
      title = "编辑收货地址";
    }
    this.manageType = query.type;
    document.title = title;
    if (query.id) {
      this.getAddressDetail(query.id);
    }
  },
  methods: {
    getAddressDetail(id) {
      this.$http
        .request(this.$http.pathMap.addressDetail, "get", { id: id })
        .then((res) => {
          this.AddressInfo = {
            ...res.data,
            isDefault: res.data.defaulted,
            tel: res.data.phone,
            addressDetail: res.data.detail,
            areaCode: res.data.areaCode.toString(),
          };
        });
    },
    onSave(content) {
      let params = {
        ...content,
        defaulted: content.isDefault,
        detail: content.addressDetail,
        phone: content.tel,
      };
      this.$http
        .request(this.$http.pathMap.addressSave, "post", params)
        .then((res) => {
          this.$toast(`地址${this.manageType == "edit" ? "修改" : "添加"}成功`);
          setTimeout(() => {
            this.$router.back();
          }, 800);
        });
    },
    onDelete(content) {
      console.log(content);
      this.$http
        .request(this.$http.pathMap.addressDelete + "/" + content.id, "get")
        .then((res) => {
          this.$router.go(-1);
        });
    },
    telValidator(val) {
      if (!/(^1[3|4|5|7|8][0-9]{9}$)/.test(val)) {
        return false;
      }
      return true;
    },
    handleDelete() {},
  },
};
</script>

<style lang="scss" scoped>
.content {
  height: 100%;
}
</style>
